
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photography-awards/categories",
      function () {
        return require("private-next-pages/photography-awards/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photography-awards/categories"])
      });
    }
  